var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenV(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.863,
    height: 14.763,
    viewBox: "0 0 19.863 14.763",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_232325",
    "data-name": "Group 232325",
    transform: "translate(-620.257 -231.596)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13978",
    "data-name": "Rectangle 13978",
    width: 9.836,
    height: 3.078,
    rx: 1.539,
    transform: "translate(622.434 237.226) rotate(45)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13979",
    "data-name": "Rectangle 13979",
    width: 17.799,
    height: 3.078,
    rx: 1.539,
    transform: "translate(640.12 233.773) rotate(135)",
    fill: "#19bc9c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenV);
export default __webpack_public_path__ + "static/media/green-v.a0c3268ccce922b55d91bb0803a5f06f.svg";
export { ForwardRef as ReactComponent };